import MultiImageUpload from "./MultiImageUpload";

export default MultiImageUpload;
